var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 497 497",
    height: 512,
    viewBox: "0 0 497 497",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m248.5 255.475-15 15.784v193.743c0 10.321 3.115 20.32 8.825 28.741 2.944 4.342 9.406 4.342 12.351 0 5.71-8.421 8.825-18.42 8.825-28.741v-193.743z",
    fill: "#acd5df"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m233.5 212v59.259c4.935.487 9.938 0 15 0s10.065.487 15 0v-59.259z",
    fill: "#93b7c0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m248.5 0v242c66.826 0 121-54.174 121-121s-54.174-121-121-121z",
    fill: "#cc3245"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m339.5 121c0-66.826-40.742-121-91-121-66.826 0-121 54.174-121 121s54.174 121 121 121c50.258 0 91-54.174 91-121z",
    fill: "#ff3e3a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.9b831582d7a6f0ab08d7c400b696df07.svg";
export { ForwardRef as ReactComponent };